import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "https://api.merakzy.mk/api", 
 // baseURL: "https://localhost:44384/api", 
  headers: {
    "Content-Type": "application/json",
     "X-Api-Key": "237ab141-d921-42c8-a39f-479b24e78974"
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    // const token = localStorage.getItem("token");
    // if (token) config.headers["Authorization"] = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error("API Error:", error.response?.data || error.message);
    return Promise.reject(error);
  }
);

export default axiosInstance;